import { render, staticRenderFns } from "./MergeFieldMenuOption.vue?vue&type=template&id=77bc6446&scoped=true"
import script from "./MergeFieldMenuOption.vue?vue&type=script&lang=js"
export * from "./MergeFieldMenuOption.vue?vue&type=script&lang=js"
import style0 from "./MergeFieldMenuOption.vue?vue&type=style&index=0&id=77bc6446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc6446",
  null
  
)

export default component.exports